/**
 * @function to getLimit apis
 * @param var originationIsoCode,destinationIsoCode and limitRequest
 * @returns api return success and error callback for limit response
 */


// Helper to handle limit response
function handleLimitR4Response(limitResponse, payIn, serviceCode, limitAttribute) {
    if (limitResponse?.error?.code === 'C1561') {
        console.error('error from trigger Limit API ');
        return;
    }
    let transactionLimit = limitResponse?.limits
    let maxLimitObj = transactionLimit?.reduce((maxObj, curr) => {
        const currMaxLimit = curr.maxLimit
        const maxLimit = maxObj.maxLimit
        return (Number(currMaxLimit) > Number(maxLimit)) ? curr : maxObj;
    }, transactionLimit[0]);
    // If serviceCode is blank or null, use the largest max_limit from transactionLimit
    if (!serviceCode && transactionLimit?.length) {
        if (maxLimitObj !== undefined) {
            let maxLimitVal = maxLimitObj.maxLimit
            let sendAmountLimit = Number(maxLimitVal) / 100;
            limitAttribute.setAttribute('data-send-up-to-amount-limit', sendAmountLimit.toFixed(2));
            sessionStorage.setItem('sendAmountLimit', sendAmountLimit.toFixed(2));
        }
        return;
    }

    let transactionLimits = limitResponse?.transactionLimit;

    const toUpperSnakeCase = (s = "") => 
        String(s)
            .replace(/\s+/g, "_")
            .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
            .toUpperCase()

    let normalizedPayIn = toUpperSnakeCase(CloudPayInNames[payIn]);        

    // check if exact payin and service code match exists,
    //  if not check for payin match with any service code, 
    // if not check for service code match with any payin, 
    // if not assign the max limit from transaction limits
    let amountLimit = transactionLimits?.find(transactionLimit =>  (transactionLimit.payIn === normalizedPayIn) && (transactionLimit.serviceCode === serviceCode))
        || transactionLimits?.find(transactionLimit => (transactionLimit.payIn === normalizedPayIn))
        || maxLimitObj && {
            limit: maxLimitObj.maxLimit
        }
// });
    if (amountLimit !== undefined && amountLimit?.limit) {
        let sendAmountLimit = Number(amountLimit.limit) / 100;
        limitAttribute.setAttribute('data-send-up-to-amount-limit', sendAmountLimit.toFixed(2));
        sessionStorage.setItem('sendAmountLimit', sendAmountLimit.toFixed(2));
    }
}

const getlimitAPIR4 = async (originationIsoCode, destinationIsoCode, serviceCode, payIn, limitAttribute, country, lang) => {
    try {
        const response = await triggerRouterCreateSession(country, lang)
        const limitResponse = await getLimitRouterApi(
            {
                senderCountry: originationIsoCode.country,
                senderCurrency: originationIsoCode.currency,
                receiverCountry: destinationIsoCode.country,
                receiverCurrency: destinationIsoCode.currency,
                sessionId: response?.sessionId
            })
        handleLimitR4Response(limitResponse.data.limits, payIn, serviceCode, limitAttribute);
        
    } catch (e) {
        console.error('error from trigger Session API  : ', e)
    }
}